(function() {
  "use strict";
  try {
    if (typeof document != "undefined") {
      var elementStyle = document.createElement("style");
      elementStyle.appendChild(document.createTextNode(".clay-quantity-grid-table-container {\n  width: 100%;\n}\n\n.clay-quantity-grid-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  /* font-size: 13px; */\n  border: 1px solid #242833bf;\n  margin-bottom: 8px;\n  margin-top: 12px;\n}\n\n.clay-quantity-grid-table thead th {\n  border-bottom: 1px solid #242833bf;\n  padding: 8px;\n  text-align: left;\n  font-weight: normal;\n  /* background-color: #f0f0f0; */\n}\n\n.clay-quantity-grid-table tbody td {\n  padding: 8px;\n  border-bottom: 1px solid #242833bf;\n}\n\n.clay-quantity-grid-table tbody tr:last-child td {\n  border-bottom: none;\n}"));
      document.head.appendChild(elementStyle);
    }
  } catch (e) {
    console.error("vite-plugin-css-injected-by-js", e);
  }
})();
!function() {
  "use strict";
  var e, t, r, n, i, o, a, c, l, s, u, p = {}, d = [], _ = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, y = Array.isArray;
  function f(e2, t2) {
    for (var r2 in t2) e2[r2] = t2[r2];
    return e2;
  }
  function m(e2) {
    e2 && e2.parentNode && e2.parentNode.removeChild(e2);
  }
  function g(e2, n2, i2, o2, a2) {
    var c2 = { type: e2, props: n2, key: i2, ref: o2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: null == a2 ? ++r : a2, __i: -1, __u: 0 };
    return null == a2 && null != t.vnode && t.vnode(c2), c2;
  }
  function h(e2) {
    return e2.children;
  }
  function P(e2, t2) {
    this.props = e2, this.context = t2;
  }
  function v(e2, t2) {
    if (null == t2) return e2.__ ? v(e2.__, e2.__i + 1) : null;
    for (var r2; t2 < e2.__k.length; t2++) if (null != (r2 = e2.__k[t2]) && null != r2.__e) return r2.__e;
    return "function" == typeof e2.type ? v(e2) : null;
  }
  function F(e2) {
    var t2, r2;
    if (null != (e2 = e2.__) && null != e2.__c) {
      for (e2.__e = e2.__c.base = null, t2 = 0; t2 < e2.__k.length; t2++) if (null != (r2 = e2.__k[t2]) && null != r2.__e) {
        e2.__e = e2.__c.base = r2.__e;
        break;
      }
      return F(e2);
    }
  }
  function x(e2) {
    (!e2.__d && (e2.__d = true) && n.push(e2) && !$.__r++ || i !== t.debounceRendering) && ((i = t.debounceRendering) || o)($);
  }
  function $() {
    for (var e2, r2, i2, o2, c2, l2, s2, u2 = 1; n.length; ) n.length > u2 && n.sort(a), e2 = n.shift(), u2 = n.length, e2.__d && (i2 = void 0, c2 = (o2 = (r2 = e2).__v).__e, l2 = [], s2 = [], r2.__P && ((i2 = f({}, o2)).__v = o2.__v + 1, t.vnode && t.vnode(i2), q(r2.__P, i2, o2, r2.__n, r2.__P.namespaceURI, 32 & o2.__u ? [c2] : null, l2, null == c2 ? v(o2) : c2, !!(32 & o2.__u), s2), i2.__v = o2.__v, i2.__.__k[i2.__i] = i2, O(l2, i2, s2), i2.__e != c2 && F(i2)));
    $.__r = 0;
  }
  function w(e2, t2, r2, n2, i2, o2, a2, c2, l2, s2, u2) {
    var _2, y2, f2, m2, g2, h2, P2 = n2 && n2.__k || d, v2 = t2.length;
    for (l2 = b(r2, t2, P2, l2, v2), _2 = 0; _2 < v2; _2++) null != (f2 = r2.__k[_2]) && (y2 = -1 === f2.__i ? p : P2[f2.__i] || p, f2.__i = _2, h2 = q(e2, f2, y2, i2, o2, a2, c2, l2, s2, u2), m2 = f2.__e, f2.ref && y2.ref != f2.ref && (y2.ref && N(y2.ref, null, f2), u2.push(f2.ref, f2.__c || m2, f2)), null == g2 && null != m2 && (g2 = m2), 4 & f2.__u || y2.__k === f2.__k ? l2 = T(f2, l2, e2) : "function" == typeof f2.type && void 0 !== h2 ? l2 = h2 : m2 && (l2 = m2.nextSibling), f2.__u &= -7);
    return r2.__e = g2, l2;
  }
  function b(e2, t2, r2, n2, i2) {
    var o2, a2, c2, l2, s2, u2 = r2.length, p2 = u2, d2 = 0;
    for (e2.__k = new Array(i2), o2 = 0; o2 < i2; o2++) null != (a2 = t2[o2]) && "boolean" != typeof a2 && "function" != typeof a2 ? (l2 = o2 + d2, (a2 = e2.__k[o2] = "string" == typeof a2 || "number" == typeof a2 || "bigint" == typeof a2 || a2.constructor == String ? g(null, a2, null, null, null) : y(a2) ? g(h, { children: a2 }, null, null, null) : void 0 === a2.constructor && a2.__b > 0 ? g(a2.type, a2.props, a2.key, a2.ref ? a2.ref : null, a2.__v) : a2).__ = e2, a2.__b = e2.__b + 1, c2 = null, -1 !== (s2 = a2.__i = C(a2, r2, l2, p2)) && (p2--, (c2 = r2[s2]) && (c2.__u |= 2)), null == c2 || null === c2.__v ? (-1 == s2 && (i2 > u2 ? d2-- : i2 < u2 && d2++), "function" != typeof a2.type && (a2.__u |= 4)) : s2 != l2 && (s2 == l2 - 1 ? d2-- : s2 == l2 + 1 ? d2++ : (s2 > l2 ? d2-- : d2++, a2.__u |= 4))) : e2.__k[o2] = null;
    if (p2) for (o2 = 0; o2 < u2; o2++) null != (c2 = r2[o2]) && !(2 & c2.__u) && (c2.__e == n2 && (n2 = v(c2)), E(c2, c2));
    return n2;
  }
  function T(e2, t2, r2) {
    var n2, i2;
    if ("function" == typeof e2.type) {
      for (n2 = e2.__k, i2 = 0; n2 && i2 < n2.length; i2++) n2[i2] && (n2[i2].__ = e2, t2 = T(n2[i2], t2, r2));
      return t2;
    }
    e2.__e != t2 && (t2 && e2.type && !r2.contains(t2) && (t2 = v(e2)), r2.insertBefore(e2.__e, t2 || null), t2 = e2.__e);
    do {
      t2 = t2 && t2.nextSibling;
    } while (null != t2 && 8 == t2.nodeType);
    return t2;
  }
  function C(e2, t2, r2, n2) {
    var i2, o2, a2 = e2.key, c2 = e2.type, l2 = t2[r2];
    if (null === l2 && null == e2.key || l2 && a2 == l2.key && c2 === l2.type && !(2 & l2.__u)) return r2;
    if (n2 > (null == l2 || 2 & l2.__u ? 0 : 1)) for (i2 = r2 - 1, o2 = r2 + 1; i2 >= 0 || o2 < t2.length; ) {
      if (i2 >= 0) {
        if ((l2 = t2[i2]) && !(2 & l2.__u) && a2 == l2.key && c2 === l2.type) return i2;
        i2--;
      }
      if (o2 < t2.length) {
        if ((l2 = t2[o2]) && !(2 & l2.__u) && a2 == l2.key && c2 === l2.type) return o2;
        o2++;
      }
    }
    return -1;
  }
  function k(e2, t2, r2) {
    "-" == t2[0] ? e2.setProperty(t2, null == r2 ? "" : r2) : e2[t2] = null == r2 ? "" : "number" != typeof r2 || _.test(t2) ? r2 : r2 + "px";
  }
  function S(e2, t2, r2, n2, i2) {
    var o2;
    e: if ("style" == t2) if ("string" == typeof r2) e2.style.cssText = r2;
    else {
      if ("string" == typeof n2 && (e2.style.cssText = n2 = ""), n2) for (t2 in n2) r2 && t2 in r2 || k(e2.style, t2, "");
      if (r2) for (t2 in r2) n2 && r2[t2] === n2[t2] || k(e2.style, t2, r2[t2]);
    }
    else if ("o" == t2[0] && "n" == t2[1]) o2 = t2 != (t2 = t2.replace(c, "$1")), t2 = t2.toLowerCase() in e2 || "onFocusOut" == t2 || "onFocusIn" == t2 ? t2.toLowerCase().slice(2) : t2.slice(2), e2.l || (e2.l = {}), e2.l[t2 + o2] = r2, r2 ? n2 ? r2.t = n2.t : (r2.t = l, e2.addEventListener(t2, o2 ? u : s, o2)) : e2.removeEventListener(t2, o2 ? u : s, o2);
    else {
      if ("http://www.w3.org/2000/svg" == i2) t2 = t2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if ("width" != t2 && "height" != t2 && "href" != t2 && "list" != t2 && "form" != t2 && "tabIndex" != t2 && "download" != t2 && "rowSpan" != t2 && "colSpan" != t2 && "role" != t2 && "popover" != t2 && t2 in e2) try {
        e2[t2] = null == r2 ? "" : r2;
        break e;
      } catch (e3) {
      }
      "function" == typeof r2 || (null == r2 || false === r2 && "-" != t2[4] ? e2.removeAttribute(t2) : e2.setAttribute(t2, "popover" == t2 && 1 == r2 ? "" : r2));
    }
  }
  function A(e2) {
    return function(r2) {
      if (this.l) {
        var n2 = this.l[r2.type + e2];
        if (null == r2.u) r2.u = l++;
        else if (r2.u < n2.t) return;
        return n2(t.event ? t.event(r2) : r2);
      }
    };
  }
  function q(e2, r2, n2, i2, o2, a2, c2, l2, s2, u2) {
    var p2, d2, _2, g2, v2, F2, x2, b2, T2, C2, k2, $2, S2, A2, q2, O2, N2, E2 = r2.type;
    if (void 0 !== r2.constructor) return null;
    128 & n2.__u && (s2 = !!(32 & n2.__u), a2 = [l2 = r2.__e = n2.__e]), (p2 = t.__b) && p2(r2);
    e: if ("function" == typeof E2) try {
      if (b2 = r2.props, T2 = "prototype" in E2 && E2.prototype.render, C2 = (p2 = E2.contextType) && i2[p2.__c], k2 = p2 ? C2 ? C2.props.value : p2.__ : i2, n2.__c ? x2 = (d2 = r2.__c = n2.__c).__ = d2.__E : (T2 ? r2.__c = d2 = new E2(b2, k2) : (r2.__c = d2 = new P(b2, k2), d2.constructor = E2, d2.render = I), C2 && C2.sub(d2), d2.props = b2, d2.state || (d2.state = {}), d2.context = k2, d2.__n = i2, _2 = d2.__d = true, d2.__h = [], d2._sb = []), T2 && null == d2.__s && (d2.__s = d2.state), T2 && null != E2.getDerivedStateFromProps && (d2.__s == d2.state && (d2.__s = f({}, d2.__s)), f(d2.__s, E2.getDerivedStateFromProps(b2, d2.__s))), g2 = d2.props, v2 = d2.state, d2.__v = r2, _2) T2 && null == E2.getDerivedStateFromProps && null != d2.componentWillMount && d2.componentWillMount(), T2 && null != d2.componentDidMount && d2.__h.push(d2.componentDidMount);
      else {
        if (T2 && null == E2.getDerivedStateFromProps && b2 !== g2 && null != d2.componentWillReceiveProps && d2.componentWillReceiveProps(b2, k2), !d2.__e && (null != d2.shouldComponentUpdate && false === d2.shouldComponentUpdate(b2, d2.__s, k2) || r2.__v == n2.__v)) {
          for (r2.__v != n2.__v && (d2.props = b2, d2.state = d2.__s, d2.__d = false), r2.__e = n2.__e, r2.__k = n2.__k, r2.__k.some(function(e3) {
            e3 && (e3.__ = r2);
          }), $2 = 0; $2 < d2._sb.length; $2++) d2.__h.push(d2._sb[$2]);
          d2._sb = [], d2.__h.length && c2.push(d2);
          break e;
        }
        null != d2.componentWillUpdate && d2.componentWillUpdate(b2, d2.__s, k2), T2 && null != d2.componentDidUpdate && d2.__h.push(function() {
          d2.componentDidUpdate(g2, v2, F2);
        });
      }
      if (d2.context = k2, d2.props = b2, d2.__P = e2, d2.__e = false, S2 = t.__r, A2 = 0, T2) {
        for (d2.state = d2.__s, d2.__d = false, S2 && S2(r2), p2 = d2.render(d2.props, d2.state, d2.context), q2 = 0; q2 < d2._sb.length; q2++) d2.__h.push(d2._sb[q2]);
        d2._sb = [];
      } else do {
        d2.__d = false, S2 && S2(r2), p2 = d2.render(d2.props, d2.state, d2.context), d2.state = d2.__s;
      } while (d2.__d && ++A2 < 25);
      d2.state = d2.__s, null != d2.getChildContext && (i2 = f(f({}, i2), d2.getChildContext())), T2 && !_2 && null != d2.getSnapshotBeforeUpdate && (F2 = d2.getSnapshotBeforeUpdate(g2, v2)), O2 = p2, null != p2 && p2.type === h && null == p2.key && (O2 = R(p2.props.children)), l2 = w(e2, y(O2) ? O2 : [O2], r2, n2, i2, o2, a2, c2, l2, s2, u2), d2.base = r2.__e, r2.__u &= -161, d2.__h.length && c2.push(d2), x2 && (d2.__E = d2.__ = null);
    } catch (e3) {
      if (r2.__v = null, s2 || null != a2) if (e3.then) {
        for (r2.__u |= s2 ? 160 : 128; l2 && 8 == l2.nodeType && l2.nextSibling; ) l2 = l2.nextSibling;
        a2[a2.indexOf(l2)] = null, r2.__e = l2;
      } else for (N2 = a2.length; N2--; ) m(a2[N2]);
      else r2.__e = n2.__e, r2.__k = n2.__k;
      t.__e(e3, r2, n2);
    }
    else null == a2 && r2.__v == n2.__v ? (r2.__k = n2.__k, r2.__e = n2.__e) : l2 = r2.__e = L(n2.__e, r2, n2, i2, o2, a2, c2, s2, u2);
    return (p2 = t.diffed) && p2(r2), 128 & r2.__u ? void 0 : l2;
  }
  function O(e2, r2, n2) {
    for (var i2 = 0; i2 < n2.length; i2++) N(n2[i2], n2[++i2], n2[++i2]);
    t.__c && t.__c(r2, e2), e2.some(function(r3) {
      try {
        e2 = r3.__h, r3.__h = [], e2.some(function(e3) {
          e3.call(r3);
        });
      } catch (e3) {
        t.__e(e3, r3.__v);
      }
    });
  }
  function R(e2) {
    return "object" != typeof e2 || null == e2 ? e2 : y(e2) ? e2.map(R) : f({}, e2);
  }
  function L(r2, n2, i2, o2, a2, c2, l2, s2, u2) {
    var d2, _2, f2, g2, h2, P2, F2, x2 = i2.props, b2 = n2.props, T2 = n2.type;
    if ("svg" == T2 ? a2 = "http://www.w3.org/2000/svg" : "math" == T2 ? a2 = "http://www.w3.org/1998/Math/MathML" : a2 || (a2 = "http://www.w3.org/1999/xhtml"), null != c2) {
      for (d2 = 0; d2 < c2.length; d2++) if ((h2 = c2[d2]) && "setAttribute" in h2 == !!T2 && (T2 ? h2.localName == T2 : 3 == h2.nodeType)) {
        r2 = h2, c2[d2] = null;
        break;
      }
    }
    if (null == r2) {
      if (null == T2) return document.createTextNode(b2);
      r2 = document.createElementNS(a2, T2, b2.is && b2), s2 && (t.__m && t.__m(n2, c2), s2 = false), c2 = null;
    }
    if (null === T2) x2 === b2 || s2 && r2.data === b2 || (r2.data = b2);
    else {
      if (c2 = c2 && e.call(r2.childNodes), x2 = i2.props || p, !s2 && null != c2) for (x2 = {}, d2 = 0; d2 < r2.attributes.length; d2++) x2[(h2 = r2.attributes[d2]).name] = h2.value;
      for (d2 in x2) if (h2 = x2[d2], "children" == d2) ;
      else if ("dangerouslySetInnerHTML" == d2) f2 = h2;
      else if (!(d2 in b2)) {
        if ("value" == d2 && "defaultValue" in b2 || "checked" == d2 && "defaultChecked" in b2) continue;
        S(r2, d2, null, h2, a2);
      }
      for (d2 in b2) h2 = b2[d2], "children" == d2 ? g2 = h2 : "dangerouslySetInnerHTML" == d2 ? _2 = h2 : "value" == d2 ? P2 = h2 : "checked" == d2 ? F2 = h2 : s2 && "function" != typeof h2 || x2[d2] === h2 || S(r2, d2, h2, x2[d2], a2);
      if (_2) s2 || f2 && (_2.__html === f2.__html || _2.__html === r2.innerHTML) || (r2.innerHTML = _2.__html), n2.__k = [];
      else if (f2 && (r2.innerHTML = ""), w("template" === n2.type ? r2.content : r2, y(g2) ? g2 : [g2], n2, i2, o2, "foreignObject" == T2 ? "http://www.w3.org/1999/xhtml" : a2, c2, l2, c2 ? c2[0] : i2.__k && v(i2, 0), s2, u2), null != c2) for (d2 = c2.length; d2--; ) m(c2[d2]);
      s2 || (d2 = "value", "progress" == T2 && null == P2 ? r2.removeAttribute("value") : void 0 !== P2 && (P2 !== r2[d2] || "progress" == T2 && !P2 || "option" == T2 && P2 !== x2[d2]) && S(r2, d2, P2, x2[d2], a2), d2 = "checked", void 0 !== F2 && F2 !== r2[d2] && S(r2, d2, F2, x2[d2], a2));
    }
    return r2;
  }
  function N(e2, r2, n2) {
    try {
      if ("function" == typeof e2) {
        var i2 = "function" == typeof e2.__u;
        i2 && e2.__u(), i2 && null == r2 || (e2.__u = e2(r2));
      } else e2.current = r2;
    } catch (e3) {
      t.__e(e3, n2);
    }
  }
  function E(e2, r2, n2) {
    var i2, o2;
    if (t.unmount && t.unmount(e2), (i2 = e2.ref) && (i2.current && i2.current !== e2.__e || N(i2, null, r2)), null != (i2 = e2.__c)) {
      if (i2.componentWillUnmount) try {
        i2.componentWillUnmount();
      } catch (e3) {
        t.__e(e3, r2);
      }
      i2.base = i2.__P = null;
    }
    if (i2 = e2.__k) for (o2 = 0; o2 < i2.length; o2++) i2[o2] && E(i2[o2], r2, n2 || "function" != typeof e2.type);
    n2 || m(e2.__e), e2.__c = e2.__ = e2.__e = void 0;
  }
  function I(e2, t2, r2) {
    return this.constructor(e2, r2);
  }
  function D(r2, n2, i2) {
    var o2, a2, c2;
    n2 == document && (n2 = document.documentElement), t.__ && t.__(r2, n2), o2 = false ? null : n2.__k, a2 = [], c2 = [], q(n2, r2 = n2.__k = function(t2, r3, n3) {
      var i3, o3, a3, c3 = {};
      for (a3 in r3) "key" == a3 ? i3 = r3[a3] : "ref" == a3 ? o3 = r3[a3] : c3[a3] = r3[a3];
      if (arguments.length > 2 && (c3.children = arguments.length > 3 ? e.call(arguments, 2) : n3), "function" == typeof t2 && null != t2.defaultProps) for (a3 in t2.defaultProps) void 0 === c3[a3] && (c3[a3] = t2.defaultProps[a3]);
      return g(t2, c3, i3, o3, null);
    }(h, null, [r2]), o2 || p, p, n2.namespaceURI, o2 ? null : n2.firstChild ? e.call(n2.childNodes) : null, a2, o2 ? o2.__e : n2.firstChild, false, c2), O(a2, r2, c2);
  }
  e = d.slice, t = { __e: function(e2, t2, r2, n2) {
    for (var i2, o2, a2; t2 = t2.__; ) if ((i2 = t2.__c) && !i2.__) try {
      if ((o2 = i2.constructor) && null != o2.getDerivedStateFromError && (i2.setState(o2.getDerivedStateFromError(e2)), a2 = i2.__d), null != i2.componentDidCatch && (i2.componentDidCatch(e2, n2 || {}), a2 = i2.__d), a2) return i2.__E = i2;
    } catch (t3) {
      e2 = t3;
    }
    throw e2;
  } }, r = 0, P.prototype.setState = function(e2, t2) {
    var r2;
    r2 = null != this.__s && this.__s !== this.state ? this.__s : this.__s = f({}, this.state), "function" == typeof e2 && (e2 = e2(f({}, r2), this.props)), e2 && f(r2, e2), null != e2 && this.__v && (t2 && this._sb.push(t2), x(this));
  }, P.prototype.forceUpdate = function(e2) {
    this.__v && (this.__e = true, e2 && this.__h.push(e2), x(this));
  }, P.prototype.render = h, n = [], o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, a = function(e2, t2) {
    return e2.__v.__b - t2.__v.__b;
  }, $.__r = 0, c = /(PointerCapture)$|Capture$/i, l = 0, s = A(false), u = A(true);
  var j = 0;
  function U(e2, r2, n2, i2, o2, a2) {
    r2 || (r2 = {});
    var c2, l2, s2 = r2;
    if ("ref" in s2) for (l2 in s2 = {}, r2) "ref" == l2 ? c2 = r2[l2] : s2[l2] = r2[l2];
    var u2 = { type: e2, props: s2, key: n2, ref: c2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: --j, __i: -1, __u: 0, __source: o2, __self: a2 };
    if ("function" == typeof e2 && (c2 = e2.defaultProps)) for (l2 in c2) void 0 === s2[l2] && (s2[l2] = c2[l2]);
    return t.vnode && t.vnode(u2), u2;
  }
  const B = /* @__PURE__ */ new Map(), G = (e2) => Date.now() - e2 > 3e5, M = async ({ shopDomain: e2, accessToken: t2, query: r2, variables: n2 }) => {
    try {
      const i2 = `https://${e2}/api/2024-07/graphql.json`, o2 = { "X-Shopify-Storefront-Access-Token": t2, "Content-Type": "application/json" }, a2 = await fetch(i2, { method: "POST", headers: o2, body: JSON.stringify({ query: r2, variables: n2 }) });
      return await a2.json();
    } catch (e3) {
      throw console.log("error", e3), e3;
    }
  }, H = async (e2, t2, r2, n2, i2, o2) => {
    var _a, _b, _c, _d, _e2, _f, _g, _h, _i, _j, _k, _l;
    const a2 = ((e3, t3, r3, n3, i3) => `${e3}:${t3}:${r3}:${JSON.stringify(n3)}:${i3}`)(e2, r2, n2, i2, o2), c2 = B.get(a2);
    if (c2 && !G(c2.timestamp)) return c2.data;
    try {
      let c3, l2 = true, s2 = [];
      for (; l2; ) {
        const a3 = await M({ shopDomain: e2, accessToken: t2, query: `query fetchProductVariantMetafield($handle: String!, $country: CountryCode) @inContext(country: $country){
                    product(handle: $handle) {
                        title
                        handle
                        variants(first: 250,after: ${c3 ? `"${c3}"` : "null"}){
                            edges{
                                node{
                                    id
                                    title
                                    metafield(namespace: "app--173437812737--clay", key: "pricing_rule"){
                                        value
                                        type
                                    }
                                    price{
                                      amount
                                      currencyCode
                                    }
                                    compareAtPrice{
                                      amount
                                      currencyCode
                                    }
                                }
                            }
                            pageInfo{
                                hasNextPage
                                endCursor
                            }
                        }
                    }
                }`, variables: { handle: r2, country: o2 } });
        if (!((_a = a3.data) == null ? void 0 : _a.product)) return l2 = false, console.log("No products found"), [];
        const u3 = (_d = (_c = (_b = a3.data) == null ? void 0 : _b.product) == null ? void 0 : _c.variants) == null ? void 0 : _d.edges.map((e3) => {
          var _a2;
          const t3 = e3.node, r3 = t3.id.split("/").pop(), o3 = (_a2 = t3.metafield) == null ? void 0 : _a2.value, a4 = W("string" == typeof o3 ? JSON.parse(o3) : []);
          let c4 = a4.find((e4) => e4.customerGroupId === n2 && !["LOGGED_IN", "ALL"].includes(n2) || i2.includes(e4.customerTag));
          c4 || "ALL" === n2 || (c4 = a4.find((e4) => "LOGGED_IN" === e4.customerGroupId)), c4 || (c4 = a4.find((e4) => "ALL" === e4.customerGroupId));
          const l3 = window.clayMarketHandle;
          window.clayCountryCurrency;
          if (c4) {
            let e4 = c4.markets.find((e5) => e5.handle === l3 || "" === e5.handle) || null;
            if (e4) {
              const n3 = { ...c4, markets: [e4] };
              if ("" === n3.ownerId || n3.ownerId === r3.split("/").pop()) return { id: r3, title: t3.title, pricingRule: n3, price: t3.price, compareAtPrice: t3.compareAtPrice };
            }
          }
          return { id: r3, title: t3.title, pricingRule: null, price: t3.price, compareAtPrice: t3.compareAtPrice };
        });
        s2.push(...u3), l2 = (_h = (_g = (_f = (_e2 = a3.data) == null ? void 0 : _e2.product) == null ? void 0 : _f.variants) == null ? void 0 : _g.pageInfo) == null ? void 0 : _h.hasNextPage, c3 = (_l = (_k = (_j = (_i = a3.data) == null ? void 0 : _i.product) == null ? void 0 : _j.variants) == null ? void 0 : _k.pageInfo) == null ? void 0 : _l.endCursor;
      }
      const u2 = { handle: r2, allVariants: s2 };
      return B.set(a2, { data: u2, timestamp: Date.now() }), V(), u2;
    } catch (e3) {
      throw console.error("Error fetching product metafield:", e3), e3;
    }
  };
  function W(e2) {
    if (!Array.isArray(e2) || 0 === e2.length) return [];
    const t2 = e2[0];
    return "customerGroupId" in t2 ? (r2 = e2, Array.isArray(r2) ? r2.map((e3 = {}) => {
      const { customerGroupId: t3 = "", customerTag: r3 = "", type: n2 = "WHOLESALE", wholesalePrice: i2 = null, quantityPrice: o2 = {} } = e3;
      let a2 = false;
      "QUANTITY" === n2 && (a2 = !!o2.isVariantUnique);
      let c2 = [];
      return "WHOLESALE" === n2 && null != i2 ? c2.push({ quantity: "1", price: i2 }) : Array.isArray(o2.value) && (c2 = o2.value), { ownerId: "", customerGroupId: t3, customerTag: r3, markets: [{ handle: "", currency: "", pricing: { type: c2.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: "A", isVariantUnique: a2, priceSource: "R", values: c2 } }] };
    }) : []) : "i" in t2 ? function(e3) {
      if (!e3 || !Array.isArray(e3)) return null;
      const t3 = e3.map((e4 = {}) => {
        let t4 = e4.o || "", [r3 = "", n2 = ""] = (e4.i || "").split("~"), i2 = e4.p.split("|").map((e5) => {
          let [t5 = "", r4 = "", n3 = "A", i3 = "0", o2 = "R", a2 = ""] = e5.split("~"), c2 = a2.split(";").map((e6) => {
            let [t6 = "1", r5 = "0"] = e6.split(":");
            return { quantity: t6, price: r5 };
          }) ?? [];
          return { handle: t5, currency: r4, pricing: { type: c2.length > 1 ? "QUANTITY" : "WHOLESALE", strategy: n3, priceSource: o2, isVariantUnique: "1" === i3, values: c2 } };
        });
        return { ownerId: t4, customerGroupId: r3, customerTag: n2, markets: i2 };
      });
      return t3;
    }(e2) : [];
    var r2;
  }
  const V = () => {
    for (const [e2, t2] of B.entries()) G(t2.timestamp) && B.delete(e2);
  };
  function Q(e2, t2) {
    if (null === e2) return "";
    const r2 = "string" == typeof e2 ? parseFloat(e2) : e2, n2 = r2.toFixed(2), i2 = r2.toFixed(0), o2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), a2 = i2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), c2 = n2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."), l2 = i2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return t2.replace("{{amount}}", n2).replace("{{amount_no_decimals}}", i2).replace("{{amount_with_comma_separator}}", o2).replace("{{amount_no_decimals_with_comma_separator}}", a2).replace("{{amount_with_period_separator}}", c2).replace("{{amount_no_decimals_with_period_separator}}", l2);
  }
  function J(e2, t2, r2) {
    var _a;
    let n2 = "", i2 = "", o2 = "", a2 = "", c2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!c2) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
    let l2 = c2.pricing.type;
    return "QUANTITY" === l2 ? { retailPriceText: n2, compareAtPriceText: i2, savingsText: o2, maxRetailPriceText: a2 } = function(e3, t3, r3, n3) {
      let i3 = n3.pricing.strategy, o3 = n3.pricing.values, a3 = n3.currency, c3 = e3.price.currencyCode, l3 = "R" === n3.pricing.priceSource ? e3.price.amount : "C" === n3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, s2 = window.marketConversionRate;
      if (!l3 || "" === l3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      let u2 = o3.filter((e4) => Number(e4.quantity) <= r3).reduce((e4, t4) => Number(t4.quantity) > Number(e4.quantity) ? t4 : e4, { price: "0", quantity: "0" }).price;
      if (a3 !== c3 && "" !== a3) {
        if (!s2 || !s2.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(i3) && (u2 = (parseFloat(u2) * s2.conversion_rate).toFixed(2).toString());
      }
      let p2 = "A" === i3 ? u2 : "P" === i3 ? (parseFloat(l3) * (1 - parseFloat(u2) / 100)).toFixed(2).toString() : "F" === i3 ? (parseFloat(l3) - parseFloat(u2)).toFixed(2).toString() : e3.price.amount;
      if ("" === a3 && s2 && s2.base_currency !== c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(p2) < 0 || parseFloat(p2) > parseFloat(e3.price.amount)) && (p2 = e3.price.amount);
      let d2 = Q(p2, clayProductPriceConfig.priceDisplayText), _2 = Q(l3, clayProductPriceConfig.compareAtPriceDisplayText), y2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(l3) - parseFloat(p2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(l3) - parseFloat(p2)) / parseFloat(l3) * 100).toFixed(2) : 0, f2 = Q(y2, clayProductPriceConfig.savingsDisplayText);
      return s2 && (d2 = window.clayCurrencySymbol + parseFloat(p2).toFixed(2) + " " + window.clayCountryCurrency, _2 = window.clayCurrencySymbol + parseFloat(l3).toFixed(2) + " " + window.clayCountryCurrency, f2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + y2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? y2 + "%" : "")), { retailPriceText: d2, compareAtPriceText: _2, savingsText: f2, maxRetailPriceText: "" };
    }(e2, 0, r2, c2) : "WHOLESALE" === l2 && ({ retailPriceText: n2, compareAtPriceText: i2, savingsText: o2, maxRetailPriceText: a2 } = function(e3, t3, r3) {
      let n3 = r3.pricing.strategy;
      r3.pricing.values;
      let i3 = r3.currency, o3 = e3.price.currencyCode, a3 = window.marketConversionRate, c3 = "R" === r3.pricing.priceSource ? e3.price.amount : "C" === r3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, l3 = r3.pricing.values[0].price;
      if (!c3 || "" === c3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      if (i3 !== o3 && "" !== i3) {
        if (!a3 || !a3.conversion_rate) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
        ["A", "F"].includes(n3) && (l3 = (parseFloat(l3) * a3.conversion_rate).toFixed(2).toString());
      }
      let s2 = "A" === n3 ? l3 : "P" === n3 ? (parseFloat(c3) * (1 - parseFloat(l3) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(c3) - parseFloat(l3)).toFixed(2).toString() : e3.price.amount;
      if ("" === i3 && a3 && a3.base_currency !== o3) return { retailPriceText: "", compareAtPriceText: "", savingsText: "", maxRetailPriceText: "" };
      (parseFloat(s2) < 0 || parseFloat(s2) > parseFloat(e3.price.amount)) && (s2 = e3.price.amount);
      let u2 = Q(s2, clayProductPriceConfig.priceDisplayText), p2 = Q(c3, clayProductPriceConfig.compareAtPriceDisplayText), d2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(c3) - parseFloat(s2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(c3) - parseFloat(s2)) / parseFloat(c3) * 100).toFixed(2) : 0, _2 = Q(d2, clayProductPriceConfig.savingsDisplayText);
      return a3 && (u2 = window.clayCurrencySymbol + parseFloat(s2).toFixed(2) + " " + window.clayCountryCurrency, p2 = window.clayCurrencySymbol + parseFloat(c3).toFixed(2) + " " + window.clayCountryCurrency, _2 = "Save " + ("amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? window.clayCurrencySymbol + d2 + " " + window.clayCountryCurrency : "percentage" === clayProductPriceConfig.savingsDisplayType ? d2 + "%" : "")), { retailPriceText: u2, compareAtPriceText: p2, savingsText: _2, maxRetailPriceText: "" };
    }(e2, 0, c2)), { retailPriceText: n2, compareAtPriceText: i2, savingsText: o2, maxRetailPriceText: a2 };
  }
  function Y(e2, t2) {
    var _a;
    let r2 = "", n2 = "", i2 = "", o2 = ((_a = e2.pricingRule) == null ? void 0 : _a.markets[0]) ?? null;
    if (!o2) return { retailPrice: "", compareAtPrice: "", savings: "" };
    let a2 = o2.pricing.type;
    return "QUANTITY" === a2 ? { retailPrice: r2, compareAtPrice: n2, savings: i2 } = function(e3, t3, r3) {
      let n3 = r3.pricing.strategy, i3 = r3.pricing.values, o3 = r3.currency, a3 = e3.price.currencyCode, c2 = "R" === r3.pricing.priceSource ? e3.price.amount : "C" === r3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, l2 = window.marketConversionRate;
      if (!c2 || "" === c2) return { retailPrice: "", compareAtPrice: "", savings: "" };
      let s2 = i3.filter((e4) => Number(e4.quantity) <= t3).reduce((e4, t4) => Number(t4.quantity) > Number(e4.quantity) ? t4 : e4, { price: "0", quantity: "0" }).price;
      if (o3 !== a3 && "" !== o3) {
        if (!l2 || !l2.conversion_rate) return { retailPrice: "", compareAtPrice: "", savings: "" };
        ["A", "F"].includes(n3) && (s2 = (parseFloat(s2) * l2.conversion_rate).toFixed(2).toString());
      }
      let u2 = "A" === n3 ? s2 : "P" === n3 ? (parseFloat(c2) * (1 - parseFloat(s2) / 100)).toFixed(2).toString() : "F" === n3 ? (parseFloat(c2) - parseFloat(s2)).toFixed(2).toString() : e3.price.amount;
      if ("" === o3 && l2 && l2.base_currency !== a3) return { retailPrice: "", compareAtPrice: "", savings: "" };
      (parseFloat(u2) < 0 || parseFloat(u2) > parseFloat(e3.price.amount)) && (u2 = e3.price.amount);
      let p2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(c2) - parseFloat(u2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(c2) - parseFloat(u2)) / parseFloat(c2) * 100).toFixed(0) : 0;
      return { retailPrice: u2, compareAtPrice: parseFloat(c2).toFixed(2), savings: p2 };
    }(e2, t2, o2) : "WHOLESALE" === a2 && ({ retailPrice: r2, compareAtPrice: n2, savings: i2 } = function(e3, t3) {
      let r3 = t3.pricing.strategy;
      t3.pricing.values;
      let n3 = t3.currency, i3 = e3.price.currencyCode, o3 = window.marketConversionRate, a3 = "R" === t3.pricing.priceSource ? e3.price.amount : "C" === t3.pricing.priceSource ? e3.compareAtPrice.amount : e3.price.amount, c2 = t3.pricing.values[0].price;
      if (!a3 || "" === a3) return { retailPrice: "", compareAtPrice: "", savings: "" };
      if (n3 !== i3 && "" !== n3) {
        if (!o3 || !o3.conversion_rate) return { retailPrice: "", compareAtPrice: "", savings: "" };
        ["A", "F"].includes(r3) && (c2 = (parseFloat(c2) * o3.conversion_rate).toFixed(2).toString());
      }
      let l2 = "A" === r3 ? c2 : "P" === r3 ? (parseFloat(a3) * (1 - parseFloat(c2) / 100)).toFixed(2).toString() : "F" === r3 ? (parseFloat(a3) - parseFloat(c2)).toFixed(2).toString() : e3.price.amount;
      if ("" === n3 && o3 && o3.base_currency !== i3) return { retailPrice: "", compareAtPrice: "", savings: "" };
      (parseFloat(l2) < 0 || parseFloat(l2) > parseFloat(e3.price.amount)) && (l2 = e3.price.amount);
      let s2 = "amountPerUnit" === clayProductPriceConfig.savingsDisplayType ? (parseFloat(a3) - parseFloat(l2)).toFixed(2) : "percentage" === clayProductPriceConfig.savingsDisplayType ? ((parseFloat(a3) - parseFloat(l2)) / parseFloat(a3) * 100).toFixed(2) : 0;
      return { retailPrice: l2, compareAtPrice: parseFloat(a3).toFixed(2), savings: s2 };
    }(e2, o2)), { retailPrice: r2, compareAtPrice: n2, savings: i2 };
  }
  function K(e2, t2, r2, n2, i2) {
    return e2.replace("{retailPriceText}", t2).replace("{compareAtPriceText}", r2).replace("{savingsText}", n2).replace("{maxRetailPriceText}", i2);
  }
  function z(e2) {
    if (!e2 || "" === e2) return null;
    let t2 = null;
    const r2 = e2.match(/\/products\/([^/?#]+)/);
    return r2 && r2[1] && (t2 = decodeURIComponent(r2[1])), t2;
  }
  async function X(e2) {
    const t2 = window.clayStorefrontConfig || {}, r2 = window.clayCustomerTier || {}, n2 = window.clayCustomerTags || [], i2 = window.clayCountryIsoCode, { allVariants: o2 } = await H(t2.shopDomain, t2.token, e2, "" === r2.customerGroupId ? "LOGGED_IN" : r2.customerGroupId, n2, i2);
    return o2;
  }
  const Z = "%[a-f0-9]{2}", ee = new RegExp("(" + Z + ")|([^%]+?)", "gi"), te = new RegExp("(" + Z + ")+", "gi");
  function re(e2, t2) {
    try {
      return [decodeURIComponent(e2.join(""))];
    } catch {
    }
    if (1 === e2.length) return e2;
    t2 = t2 || 1;
    const r2 = e2.slice(0, t2), n2 = e2.slice(t2);
    return Array.prototype.concat.call([], re(r2), re(n2));
  }
  function ne(e2) {
    try {
      return decodeURIComponent(e2);
    } catch {
      let t2 = e2.match(ee) || [];
      for (let r2 = 1; r2 < t2.length; r2++) t2 = (e2 = re(t2, r2).join("")).match(ee) || [];
      return e2;
    }
  }
  function ie(e2) {
    if ("string" != typeof e2) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e2 + "`");
    try {
      return decodeURIComponent(e2);
    } catch {
      return function(e3) {
        const t2 = { "%FE%FF": "��", "%FF%FE": "��" };
        let r2 = te.exec(e3);
        for (; r2; ) {
          try {
            t2[r2[0]] = decodeURIComponent(r2[0]);
          } catch {
            const e4 = ne(r2[0]);
            e4 !== r2[0] && (t2[r2[0]] = e4);
          }
          r2 = te.exec(e3);
        }
        t2["%C2"] = "�";
        const n2 = Object.keys(t2);
        for (const r3 of n2) e3 = e3.replace(new RegExp(r3, "g"), t2[r3]);
        return e3;
      }(e2);
    }
  }
  function oe(e2, t2) {
    const r2 = {};
    if (Array.isArray(t2)) for (const n2 of t2) {
      const t3 = Object.getOwnPropertyDescriptor(e2, n2);
      (t3 == null ? void 0 : t3.enumerable) && Object.defineProperty(r2, n2, t3);
    }
    else for (const n2 of Reflect.ownKeys(e2)) {
      const i2 = Object.getOwnPropertyDescriptor(e2, n2);
      if (i2.enumerable) {
        t2(n2, e2[n2], e2) && Object.defineProperty(r2, n2, i2);
      }
    }
    return r2;
  }
  function ae(e2, t2) {
    if ("string" != typeof e2 || "string" != typeof t2) throw new TypeError("Expected the arguments to be of type `string`");
    if ("" === e2 || "" === t2) return [];
    const r2 = e2.indexOf(t2);
    return -1 === r2 ? [] : [e2.slice(0, r2), e2.slice(r2 + t2.length)];
  }
  const ce = Symbol("encodeFragmentIdentifier");
  function le(e2) {
    if ("string" != typeof e2 || 1 !== e2.length) throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function se(e2, t2) {
    return t2.encode ? t2.strict ? encodeURIComponent(e2).replaceAll(/[!'()*]/g, (e3) => `%${e3.charCodeAt(0).toString(16).toUpperCase()}`) : encodeURIComponent(e2) : e2;
  }
  function ue(e2, t2) {
    return t2.decode ? ie(e2) : e2;
  }
  function pe(e2) {
    return Array.isArray(e2) ? e2.sort() : "object" == typeof e2 ? pe(Object.keys(e2)).sort((e3, t2) => Number(e3) - Number(t2)).map((t2) => e2[t2]) : e2;
  }
  function de(e2) {
    const t2 = e2.indexOf("#");
    return -1 !== t2 && (e2 = e2.slice(0, t2)), e2;
  }
  function _e(e2, t2, r2) {
    return "string" === r2 && "string" == typeof e2 ? e2 : "function" == typeof r2 && "string" == typeof e2 ? r2(e2) : !t2.parseBooleans || null === e2 || "true" !== e2.toLowerCase() && "false" !== e2.toLowerCase() ? "number" !== r2 || Number.isNaN(Number(e2)) || "string" != typeof e2 || "" === e2.trim() ? t2.parseNumbers && !Number.isNaN(Number(e2)) && "string" == typeof e2 && "" !== e2.trim() ? Number(e2) : e2 : Number(e2) : "true" === e2.toLowerCase();
  }
  function ye(e2) {
    const t2 = (e2 = de(e2)).indexOf("?");
    return -1 === t2 ? "" : e2.slice(t2 + 1);
  }
  function fe(e2, t2) {
    le((t2 = { decode: true, sort: true, arrayFormat: "none", arrayFormatSeparator: ",", parseNumbers: false, parseBooleans: false, types: /* @__PURE__ */ Object.create(null), ...t2 }).arrayFormatSeparator);
    const r2 = function(e3) {
      let t3;
      switch (e3.arrayFormat) {
        case "index":
          return (e4, r3, n3) => {
            t3 = /\[(\d*)]$/.exec(e4), e4 = e4.replace(/\[\d*]$/, ""), t3 ? (void 0 === n3[e4] && (n3[e4] = {}), n3[e4][t3[1]] = r3) : n3[e4] = r3;
          };
        case "bracket":
          return (e4, r3, n3) => {
            t3 = /(\[])$/.exec(e4), e4 = e4.replace(/\[]$/, ""), t3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], r3] : n3[e4] = [r3] : n3[e4] = r3;
          };
        case "colon-list-separator":
          return (e4, r3, n3) => {
            t3 = /(:list)$/.exec(e4), e4 = e4.replace(/:list$/, ""), t3 ? void 0 !== n3[e4] ? n3[e4] = [...n3[e4], r3] : n3[e4] = [r3] : n3[e4] = r3;
          };
        case "comma":
        case "separator":
          return (t4, r3, n3) => {
            const i2 = "string" == typeof r3 && r3.includes(e3.arrayFormatSeparator), o2 = "string" == typeof r3 && !i2 && ue(r3, e3).includes(e3.arrayFormatSeparator);
            r3 = o2 ? ue(r3, e3) : r3;
            const a2 = i2 || o2 ? r3.split(e3.arrayFormatSeparator).map((t5) => ue(t5, e3)) : null === r3 ? r3 : ue(r3, e3);
            n3[t4] = a2;
          };
        case "bracket-separator":
          return (t4, r3, n3) => {
            const i2 = /(\[])$/.test(t4);
            if (t4 = t4.replace(/\[]$/, ""), !i2) return void (n3[t4] = r3 ? ue(r3, e3) : r3);
            const o2 = null === r3 ? [] : ue(r3, e3).split(e3.arrayFormatSeparator);
            void 0 !== n3[t4] ? n3[t4] = [...n3[t4], ...o2] : n3[t4] = o2;
          };
        default:
          return (e4, t4, r3) => {
            void 0 !== r3[e4] ? r3[e4] = [...[r3[e4]].flat(), t4] : r3[e4] = t4;
          };
      }
    }(t2), n2 = /* @__PURE__ */ Object.create(null);
    if ("string" != typeof e2) return n2;
    if (!(e2 = e2.trim().replace(/^[?#&]/, ""))) return n2;
    for (const i2 of e2.split("&")) {
      if ("" === i2) continue;
      const e3 = t2.decode ? i2.replaceAll("+", " ") : i2;
      let [o2, a2] = ae(e3, "=");
      void 0 === o2 && (o2 = e3), a2 = void 0 === a2 ? null : ["comma", "separator", "bracket-separator"].includes(t2.arrayFormat) ? a2 : ue(a2, t2), r2(ue(o2, t2), a2, n2);
    }
    for (const [e3, r3] of Object.entries(n2)) if ("object" == typeof r3 && null !== r3 && "string" !== t2.types[e3]) for (const [n3, i2] of Object.entries(r3)) {
      const o2 = t2.types[e3] ? t2.types[e3].replace("[]", "") : void 0;
      r3[n3] = _e(i2, t2, o2);
    }
    else "object" == typeof r3 && null !== r3 && "string" === t2.types[e3] ? n2[e3] = Object.values(r3).join(t2.arrayFormatSeparator) : n2[e3] = _e(r3, t2, t2.types[e3]);
    return false === t2.sort ? n2 : (true === t2.sort ? Object.keys(n2).sort() : Object.keys(n2).sort(t2.sort)).reduce((e3, t3) => {
      const r3 = n2[t3];
      return e3[t3] = Boolean(r3) && "object" == typeof r3 && !Array.isArray(r3) ? pe(r3) : r3, e3;
    }, /* @__PURE__ */ Object.create(null));
  }
  function me(e2, t2) {
    if (!e2) return "";
    le((t2 = { encode: true, strict: true, arrayFormat: "none", arrayFormatSeparator: ",", ...t2 }).arrayFormatSeparator);
    const r2 = (r3) => t2.skipNull && null == e2[r3] || t2.skipEmptyString && "" === e2[r3], n2 = function(e3) {
      switch (e3.arrayFormat) {
        case "index":
          return (t3) => (r3, n3) => {
            const i3 = r3.length;
            return void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [se(t3, e3), "[", i3, "]"].join("")] : [...r3, [se(t3, e3), "[", se(i3, e3), "]=", se(n3, e3)].join("")];
          };
        case "bracket":
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [se(t3, e3), "[]"].join("")] : [...r3, [se(t3, e3), "[]=", se(n3, e3)].join("")];
        case "colon-list-separator":
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, [se(t3, e3), ":list="].join("")] : [...r3, [se(t3, e3), ":list=", se(n3, e3)].join("")];
        case "comma":
        case "separator":
        case "bracket-separator": {
          const t3 = "bracket-separator" === e3.arrayFormat ? "[]=" : "=";
          return (r3) => (n3, i3) => void 0 === i3 || e3.skipNull && null === i3 || e3.skipEmptyString && "" === i3 ? n3 : (i3 = null === i3 ? "" : i3, 0 === n3.length ? [[se(r3, e3), t3, se(i3, e3)].join("")] : [[n3, se(i3, e3)].join(e3.arrayFormatSeparator)]);
        }
        default:
          return (t3) => (r3, n3) => void 0 === n3 || e3.skipNull && null === n3 || e3.skipEmptyString && "" === n3 ? r3 : null === n3 ? [...r3, se(t3, e3)] : [...r3, [se(t3, e3), "=", se(n3, e3)].join("")];
      }
    }(t2), i2 = {};
    for (const [t3, n3] of Object.entries(e2)) r2(t3) || (i2[t3] = n3);
    const o2 = Object.keys(i2);
    return false !== t2.sort && o2.sort(t2.sort), o2.map((r3) => {
      const i3 = e2[r3];
      return void 0 === i3 ? "" : null === i3 ? se(r3, t2) : Array.isArray(i3) ? 0 === i3.length && "bracket-separator" === t2.arrayFormat ? se(r3, t2) + "[]" : i3.reduce(n2(r3), []).join("&") : se(r3, t2) + "=" + se(i3, t2);
    }).filter((e3) => e3.length > 0).join("&");
  }
  function ge(e2, t2) {
    var _a;
    t2 = { decode: true, ...t2 };
    let [r2, n2] = ae(e2, "#");
    return void 0 === r2 && (r2 = e2), { url: ((_a = r2 == null ? void 0 : r2.split("?")) == null ? void 0 : _a[0]) ?? "", query: fe(ye(e2), t2), ...t2 && t2.parseFragmentIdentifier && n2 ? { fragmentIdentifier: ue(n2, t2) } : {} };
  }
  function he(e2, t2) {
    t2 = { encode: true, strict: true, [ce]: true, ...t2 };
    const r2 = de(e2.url).split("?")[0] || "";
    let n2 = me({ ...fe(ye(e2.url), { sort: false }), ...e2.query }, t2);
    n2 && (n2 = `?${n2}`);
    let i2 = function(e3) {
      let t3 = "";
      const r3 = e3.indexOf("#");
      return -1 !== r3 && (t3 = e3.slice(r3)), t3;
    }(e2.url);
    if ("string" == typeof e2.fragmentIdentifier) {
      const n3 = new URL(r2);
      n3.hash = e2.fragmentIdentifier, i2 = t2[ce] ? n3.hash : `#${e2.fragmentIdentifier}`;
    }
    return `${r2}${n2}${i2}`;
  }
  function Pe(e2, t2, r2) {
    r2 = { parseFragmentIdentifier: true, [ce]: false, ...r2 };
    const { url: n2, query: i2, fragmentIdentifier: o2 } = ge(e2, r2);
    return he({ url: n2, query: oe(i2, t2), fragmentIdentifier: o2 }, r2);
  }
  const ve = Object.freeze(Object.defineProperty({ __proto__: null, exclude: function(e2, t2, r2) {
    return Pe(e2, Array.isArray(t2) ? (e3) => !t2.includes(e3) : (e3, r3) => !t2(e3, r3), r2);
  }, extract: ye, parse: fe, parseUrl: ge, pick: Pe, stringify: me, stringifyUrl: he }, Symbol.toStringTag, { value: "Module" }));
  const Fe = window.clayStorefrontConfig || {}, xe = window.clayCustomerTags || [], we = window.clayProductPriceConfig || {};
  Shopify.theme;
  const be = window.clayMarketHandle, Te = window.clayCountryCurrency, Ce = window.clayCountryIsoCode, ke = { themeName: "Warehouse", productGrid: ".product-item", productGridProductUrl: ".product-item__image-wrapper", productGridProductPrice: ".price-list", productPagePriceBlock: ".product-block-list .price-list", retailPriceBlockFormatOnProductPage: '<span class="price">{retailPriceText}</span>', comparePriceBlockFormatOnProductPage: '<span class="price price--highlight">{retailPriceText}</span><span class="price price--compare">{compareAtPriceText}</span>', searchProductGrid: ".search-bar__result-item", searchProductGridProductPriceBlock: ".search-bar__item-price", searchProductGridRetailPriceFormat: "{retailPriceText}", quickOrderModal: "#quick-buy-modal-content", quickOrderModalProductUrl: ".product-meta__title a", quickOrderModalProductPrice: ".price-list" };
  async function Se() {
    z(window.location.href) && async function() {
      var _a;
      const e2 = document.querySelectorAll(ke.productPagePriceBlock), t2 = (_a = e2[0]) == null ? void 0 : _a.parentElement;
      if (t2 == null ? void 0 : t2.__clayObserver) setTimeout(() => {
        Ae();
      }, 100);
      else {
        const e3 = new MutationObserver((e4) => {
          setTimeout(() => {
            Ae();
          }, 100);
        }), r2 = { attributes: true, childList: true, subtree: true, characterData: true };
        t2 && (e3.observe(t2, r2), t2.__clayObserver = e3, setTimeout(() => {
          Ae();
        }, 100));
      }
    }(), qe(ke, 0, 1e4), ke.quickOrderModal && Ne(ke, 0, 1e3, 0);
  }
  async function Ae() {
    var _a;
    let e2 = z(window.location.href);
    const t2 = await X(e2), r2 = new URL(window.location.href);
    let n2 = ve.parse(r2.search).variant;
    n2 || (n2 = t2[0].id);
    const i2 = t2.find((e3) => e3.id === n2);
    if (!i2.pricingRule) return;
    const o2 = document.querySelectorAll(ke.productPagePriceBlock)[0];
    if (!o2) return;
    if (o2.classList.contains("clay-wholesale-price")) return;
    o2.getAttribute("data-variant-id") !== i2.id && o2.setAttribute("data-variant-id", "");
    let { retailPrice: a2 } = Y(i2, 1);
    if ("" === a2) return;
    let { retailPriceText: c2, compareAtPriceText: l2, savingsText: s2, maxRetailPriceText: u2 } = J(i2, 0, 1);
    if ("" === c2) return;
    let p2 = K(c2 !== l2 && ke.comparePriceBlockFormatOnProductPage ? ke.comparePriceBlockFormatOnProductPage : ke.retailPriceBlockFormatOnProductPage || "{retailPriceText}", c2, l2, s2, u2);
    if ((o2.innerHTML !== p2 && !o2.classList.contains("clay-wholesale-price") || o2.getAttribute("data-variant-id") !== i2.id) && (o2.innerHTML = p2, o2.classList.add("clay-wholesale-price"), o2.setAttribute("data-variant-id", i2.id)), c2 !== l2) {
      let e3 = o2.querySelector(".clay-savings-text-container");
      o2.classList.contains(ke.isSalePriceClass) ? o2.classList.contains(ke.isSalePriceClass) && o2.classList.remove(ke.isSalePriceClass) : o2.classList.add(ke.isSalePriceClass), e3 && e3.getAttribute("data-variant-id") === i2.id || (e3 = document.createElement("div"), e3.className = "clay-savings-text-container", e3.innerHTML = s2, e3.setAttribute("data-variant-id", i2.id), o2.appendChild(e3));
    }
    if ("QUANTITY" === i2.pricingRule.markets[0].pricing.type && we.showQuantityGrid) {
      const e3 = Oe(i2, we.quantityGridTemplate);
      if (!e3) return;
      ((_a = e3[0]) == null ? void 0 : _a.price) && e3.forEach((e4) => {
        let t4 = null;
        t4 = e4.price, t4 = window.marketConversionRate ? Q(t4, window.clayCurrencySymbol + "{{amount}}") : Q(t4, we.quantityGridPriceDisplayText), e4.price = t4;
      });
      let t3 = o2.querySelector(".clay-quantity-grid-table-container");
      t3 && t3.getAttribute("data-variant-id") !== i2.id && (t3.remove(), t3 = null), t3 || (t3 = document.createElement("div"), t3.className = "clay-quantity-grid-table-container", o2.appendChild(t3), D(Re(e3), t3), t3.setAttribute("data-variant-id", i2.id));
    }
  }
  function qe(e2, t2, r2, n2) {
    let i2 = document.querySelectorAll(e2.productGrid);
    i2 = Array.from(i2).filter((t3) => {
      const r3 = t3.querySelector(e2.productGridProductPrice);
      return r3 && !r3.classList.contains("clay-wholesale-price");
    }), i2 && i2.length > 0 && function(e3, t3) {
      e3.forEach(async (e4, r3) => {
        var _a;
        const n3 = (_a = e4.querySelector(t3.productGridProductUrl)) == null ? void 0 : _a.href;
        if (!n3) return;
        let i3 = z(n3);
        const o2 = e4.querySelector(t3.productGridProductPrice);
        if (!o2 || o2.classList.contains("clay-wholesale-price")) return;
        !async function(e5, t4, r4) {
          e5.sort((e6, t5) => parseFloat(e6.price.amount) - parseFloat(t5.price.amount));
          const n4 = e5[0];
          if (!n4.pricingRule) return;
          const i4 = t4.querySelector(r4.productGridProductPrice);
          let { retailPriceText: o3, compareAtPriceText: a2, savingsText: c2, maxRetailPriceText: l2 } = J(n4, 0, 1);
          if ("" === o3) return;
          let { retailPrice: s2 } = Y(n4, 1);
          const u2 = function(e6, t5, r5, n5, i5, o4) {
            const a3 = e6.length > 1;
            if (a3) {
              if (t5.multiVariantPriceBlockWithComparePriceFormatOnCollectionsPage && r5 !== n5) return t5.multiVariantPriceBlockWithComparePriceFormatOnCollectionsPage;
              if (t5.multiVariantPriceBlockFormatOnCollectionsPage) {
                if (t5.multiVariantPriceBlockFormatOnCollectionsPage.includes("{maxRetailPriceText}") && r5 !== o4) return t5.multiVariantPriceBlockFormatOnCollectionsPage;
                if (!t5.multiVariantPriceBlockFormatOnCollectionsPage.includes("{maxRetailPriceText}")) return t5.multiVariantPriceBlockFormatOnCollectionsPage;
              }
            }
            if (t5.comparePriceBlockFormatOnCollectionsPage && r5 !== n5) return t5.comparePriceBlockFormatOnCollectionsPage;
            if (t5.comparePriceBlockFormatOnProductPage && r5 !== n5) return t5.comparePriceBlockFormatOnProductPage;
            return t5.retailPriceBlockFormatOnCollectionsPage || t5.retailPriceBlockFormatOnProductPage || "{retailPriceText}";
          }(e5, r4, o3, a2, 0, l2);
          let p2 = K(u2, o3, a2, c2, l2);
          i4.classList.contains("clay-wholesale-price") || (i4.innerHTML = p2, i4.classList.add("clay-wholesale-price"));
          o3 !== a2 ? i4.classList.contains(r4.isSalePriceClass) || i4.classList.add(r4.isSalePriceClass) : i4.classList.contains(r4.isSalePriceClass) && i4.classList.remove(r4.isSalePriceClass);
        }(await X(i3), e4, t3);
      });
    }(i2, e2), t2 < r2 && setTimeout(() => {
      qe(e2, t2 + 200, r2, i2.length);
    }, 200);
  }
  !async function() {
    await async function() {
      fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { customer_tags: (xe == null ? void 0 : xe.join(",")) || "" } }) }).then((e3) => e3.json()).catch((e3) => console.error("Error updating cart:", e3));
      let e2 = null;
      const t2 = await (async (e3, t3, r2) => {
        var _a, _b, _c, _d, _e2, _f, _g, _h;
        let n2 = null, i2 = null, o2 = null, a2 = null;
        try {
          const c2 = await M({ shopDomain: e3, accessToken: t3, query: "query HighPricedProducts($country: CountryCode) @inContext(country: $country) {\n              products(first: 1, sortKey: PRICE, reverse: true) {\n                edges {\n                  node {\n                    id\n                    title\n                    variants(first: 1) {\n                      edges {\n                        node {\n                          id\n                          price {\n                            amount\n                            currencyCode\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }", variables: { country: r2 } });
          ((_c = (_b = (_a = c2 == null ? void 0 : c2.data) == null ? void 0 : _a.products) == null ? void 0 : _b.edges) == null ? void 0 : _c.length) > 0 && (n2 = (_d = c2.data.products.edges[0].node.variants) == null ? void 0 : _d.edges[0].node.price);
          const l2 = await M({ shopDomain: e3, accessToken: t3, query: "query HighPricedProducts {\n              products(first: 1, sortKey: PRICE, reverse: true) {\n                edges {\n                  node {\n                    id\n                    title\n                    variants(first: 1) {\n                      edges {\n                        node {\n                          id\n                          price {\n                            amount\n                            currencyCode\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }" });
          if (((_g = (_f = (_e2 = l2 == null ? void 0 : l2.data) == null ? void 0 : _e2.products) == null ? void 0 : _f.edges) == null ? void 0 : _g.length) > 0 && (i2 = (_h = l2.data.products.edges[0].node.variants) == null ? void 0 : _h.edges[0].node.price), n2 && i2) {
            const e4 = i2.currencyCode;
            e4 !== n2.currencyCode && (a2 = (parseFloat(n2.amount) / parseFloat(i2.amount)).toFixed(8), o2 = e4);
          }
          return { conversionRate: a2, baseCurrency: o2 };
        } catch (e4) {
          return console.error("Error fetching conversion rate:", e4), { conversionRate: null, baseCurrency: null };
        }
      })(Fe.shopDomain, Fe.token, Ce);
      t2.conversionRate && (e2 = { conversion_rate: t2.conversionRate, base_currency: t2.baseCurrency, market_handle: be, market_currency: Te });
      window.marketConversionRate = e2, e2 && fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { market_conversion_rate: JSON.stringify(e2) } }) }).then((e3) => e3.json()).catch((e3) => console.error("Error updating cart:", e3));
    }(), function() {
      window.addEventListener("popstate", Se);
      const e2 = history.pushState;
      history.pushState = function() {
        e2.apply(this, arguments), Se();
      };
      const t2 = history.replaceState;
      history.replaceState = function() {
        t2.apply(this, arguments), Se();
      }, Se();
    }(), new MutationObserver((e2) => {
      e2.forEach((e3) => {
        e3.addedNodes.forEach((e4) => {
          if ("Warehouse" === ke.themeName) {
            if (1 === e4.nodeType && e4.querySelector(ke.searchProductGrid)) {
              let t2 = e4.querySelectorAll(ke.searchProductGrid);
              t2 && t2.length > 0 && async function(e5, t3) {
                Array.from(e5).map(async (e6) => {
                  var _a;
                  let r2 = null;
                  if (t3.searchProductGridProductUrl) {
                    const n3 = (_a = e6.querySelector(t3.searchProductGridProductUrl)) == null ? void 0 : _a.href;
                    r2 = z(n3);
                  } else r2 = t3.searchProductGridProductHandleAttribute ? e6.getAttribute(t3.searchProductGridProductHandleAttribute) : z(e6.href);
                  if (!r2) return;
                  const n2 = e6.querySelector(t3.searchProductGridProductPriceBlock);
                  if (!n2) return;
                  const i2 = await X(r2);
                  if (!i2 || 0 === i2.length) return;
                  const o2 = i2[0];
                  if (!o2.pricingRule) return;
                  const { retailPriceText: a2, compareAtPriceText: c2, savingsText: l2, maxRetailPriceText: s2 } = J(o2, 0, 1);
                  if ("" === a2) return;
                  let u2 = K(t3.searchProductGridRetailPriceFormat || t3.comparePriceBlockFormatOnProductPage || t3.retailPriceBlockFormatOnProductPage || "{retailPriceText}", a2, c2, l2, s2);
                  n2.innerHTML = u2;
                });
              }(t2, ke);
            }
            if (1 === e4.nodeType && e4.querySelector(ke.quickOrderModal)) {
              let t2 = e4.querySelectorAll(ke.quickOrderModal);
              t2 && t2.length > 0 && Le(t2, ke);
            }
            if (1 === e4.nodeType && e4.matches(".product-info__block-item--variant-selector")) {
              let t2 = e4.closest(ke.quickOrderModal);
              t2 && Le([t2], ke);
            }
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }();
  const Oe = (e2, t2) => {
    let r2 = e2.pricingRule.markets[0], n2 = r2.pricing.strategy, i2 = r2.pricing.values.map((e3) => ({ ...e3 })), o2 = r2.currency, a2 = e2.price.currencyCode, c2 = "R" === r2.pricing.priceSource ? e2.price.amount : e2.compareAtPrice.amount, l2 = window.marketConversionRate;
    if ("" === o2 && l2 && l2.base_currency !== a2) return null;
    if (!c2 || "" === c2) return null;
    switch (o2 !== a2 && "" !== o2 && l2 && l2.conversion_rate && ["A", "F"].includes(n2) && i2.forEach((e3) => {
      e3.price = (parseFloat(e3.price) * l2.conversion_rate).toFixed(2).toString();
    }), i2.forEach((t3) => {
      let r3 = "A" === n2 ? t3.price : "P" === n2 ? (parseFloat(c2) * (1 - parseFloat(t3.price) / 100)).toFixed(2).toString() : "F" === n2 ? (parseFloat(c2) - parseFloat(t3.price)).toFixed(2).toString() : e2.price.amount;
      (parseFloat(r3) < 0 || parseFloat(r3) > parseFloat(e2.price.amount)) && (r3 = e2.price.amount), t3.price = r3;
    }), t2) {
      case "quantityPrice":
        return i2.map((e3) => ({ quantity: e3.quantity, price: parseFloat(e3.price).toFixed(2) }));
      case "quantityRangePrice":
        return i2.map((e3, t3, r3) => t3 === r3.length - 1 ? { range: `${e3.quantity}+`, price: parseFloat(e3.price).toFixed(2) } : { range: `${e3.quantity}-${r3[t3 + 1].quantity - 1}`, price: parseFloat(e3.price).toFixed(2) });
      case "quantityRangeDiscount":
        return i2.map((e3, t3, r3) => t3 === r3.length - 1 ? { range: `${e3.quantity}+`, discount: ((parseFloat(c2) - parseFloat(e3.price)) / parseFloat(c2) * 100).toFixed(0) + "%" } : { range: `${e3.quantity}-${r3[t3 + 1].quantity - 1}`, discount: ((parseFloat(c2) - parseFloat(e3.price)) / parseFloat(c2) * 100).toFixed(0) + "%" });
      case "quantityBuyPrice":
        return i2.map((e3) => ({ quantity: "Buy " + e3.quantity, price: parseFloat(e3.price).toFixed(2) }));
      case "quantityPriceDiscount":
        return i2.map((e3) => ({ quantity: e3.quantity, price: parseFloat(e3.price).toFixed(2), discount: ((parseFloat(c2) - parseFloat(e3.price)) / parseFloat(c2) * 100).toFixed(0) + "%" }));
      default:
        return [];
    }
  }, Re = (e2) => {
    switch (we.quantityGridTemplate) {
      case "quantityPrice":
      case "quantityBuyPrice":
        return U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Quantity" }), U("th", { children: "Price" })] }) }), U("tbody", { children: e2.map((e3, t2) => U("tr", { children: [U("td", { children: e3.quantity }), U("td", { children: e3.price })] }, t2)) })] });
      case "quantityRangePrice":
        return U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Quantity Range" }), U("th", { children: "Price" })] }) }), U("tbody", { children: e2.map((e3, t2) => U("tr", { children: [U("td", { children: e3.range }), U("td", { children: e3.price })] }, t2)) })] });
      case "quantityRangeDiscount":
        return U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Quantity Range" }), U("th", { children: "Discount" })] }) }), U("tbody", { children: e2.map((e3, t2) => U("tr", { children: [U("td", { children: e3.range }), U("td", { children: e3.discount })] }, t2)) })] });
      case "quantityPriceDiscount":
        return U("table", { className: "clay-quantity-grid-table", children: [U("thead", { children: U("tr", { children: [U("th", { children: "Quantity" }), U("th", { children: "Price" }), U("th", { children: "Discount" })] }) }), U("tbody", { children: e2.map((e3, t2) => U("tr", { children: [U("td", { children: e3.quantity }), U("td", { children: e3.price }), U("td", { children: e3.discount })] }, t2)) })] });
      default:
        return null;
    }
  };
  async function Le(e2, t2) {
    e2.forEach(async (e3) => {
      var _a, _b;
      let r2 = z(e3.querySelector(t2.quickOrderModalProductUrl).href);
      const n2 = e3.querySelector(t2.quickOrderModalProductPrice);
      if (!n2 || n2.classList.contains("clay-wholesale-price")) return;
      let i2 = (_a = e3.querySelector("variant-picker script")) == null ? void 0 : _a.innerHTML, o2 = null;
      i2 && (o2 = (_b = JSON.parse(i2)) == null ? void 0 : _b.id);
      const a2 = await X(r2);
      a2.sort((e4, t3) => parseFloat(e4.price.amount) - parseFloat(t3.price.amount));
      const c2 = o2 ? a2.find((e4) => e4.id == Number(o2)) : a2[0];
      if (!c2.pricingRule) return;
      const { retailPriceText: l2, compareAtPriceText: s2, savingsText: u2, maxRetailPriceText: p2 } = J(c2, 0, 1);
      if ("" === l2) return;
      const d2 = l2 !== s2 && t2.comparePriceBlockFormatOnProductPage ? t2.comparePriceBlockFormatOnProductPage : t2.retailPriceBlockFormatOnProductPage || "{retailPriceText}";
      let _2 = K(d2, l2, s2, u2, p2);
      n2.innerHTML === _2 || n2.classList.contains("clay-wholesale-price") || (n2.innerHTML = _2, n2.classList.add("clay-wholesale-price"), t2.isSalePriceClass && (d2 !== t2.comparePriceBlockFormatOnProductPage || n2.classList.contains(t2.isSalePriceClass) ? d2 !== t2.comparePriceBlockFormatOnProductPage && n2.classList.contains(t2.isSalePriceClass) && n2.classList.remove(t2.isSalePriceClass) : n2.classList.add(t2.isSalePriceClass)));
    });
  }
  async function Ne(e2, t2, r2, n2) {
    let i2 = document.querySelectorAll(e2.quickOrderModal);
    i2 = Array.from(i2).filter((t3) => {
      const r3 = t3.querySelector(e2.quickOrderModalProductPrice);
      return r3 && !r3.classList.contains("clay-wholesale-price");
    }), i2 && i2.length > 0 && i2.length !== n2 && Le(i2, e2), t2 < r2 && setTimeout(() => {
      Ne(e2, t2 + 200, r2, i2.length);
    }, 200);
  }
}();
